import React from 'react';
import pulse from '@finn-no/pulse-sdk';

var classes = {"profileContainer":"ProfileBox-module_profileContainer__q8I-y","profileLogo":"ProfileBox-module_profileLogo__RzLhT","profileLogoFallback":"ProfileBox-module_profileLogoFallback__V6xMc","companyName":"ProfileBox-module_companyName__XPhPY"};

function trackPhonenr(adId, orgName) {
  var id = adId.toString();
  var pulsePayload = {
    type: 'Click',
    intent: 'Call',
    name: 'Contact seller',
    object: {
      id,
      type: 'UIElement',
      elementType: 'Phone number'
    },
    target: {
      id,
      type: 'ExternalContent',
      name: 'Phone',
      provider: orgName
    }
  };
  pulse.trackEvent(pulsePayload);
}
function trackSms(adId, orgName) {
  var id = adId.toString();
  var pulsePayload = {
    type: 'Click',
    intent: 'SMS',
    name: 'Contact seller',
    object: {
      id,
      type: 'UIElement',
      elementType: 'Phone number'
    },
    target: {
      id,
      type: 'ExternalContent',
      name: 'Phone',
      provider: orgName
    }
  };
  pulse.trackEvent(pulsePayload);
}
function trackSendMelding() {
  var pulsePayload = {
    name: 'Send message',
    type: 'Click',
    object: {
      id: 'send-msg-btn',
      type: 'UIElement',
      elementType: 'Button'
    },
    target: {
      id: 'id',
      type: 'Message'
    },
    intent: 'Create'
  };
  pulse.trackEvent(pulsePayload);
}
function trackHjemmeside(adId, orgName) {
  var id = adId.toString();
  var pulsePayload = {
    type: 'Click',
    intent: 'Open',
    name: 'Homepage link clicked',
    object: {
      id,
      type: 'UIElement',
      elementType: 'Link'
    },
    target: {
      id,
      type: 'ExternalContent',
      name: 'Go to webpage',
      provider: orgName
    }
  };
  pulse.trackEvent(pulsePayload);
}
function trackMoreAdsFrom(adId) {
  var id = adId.toString();
  var pulsePayload = {
    type: 'Click',
    intent: 'View',
    name: 'More ads from this organization',
    object: {
      id,
      type: 'UIElement',
      elementType: 'Link'
    },
    target: {
      id,
      type: 'Listing'
    }
  };
  pulse.trackEvent(pulsePayload);
}
function insertSoftHyphens(text) {
  var step = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
  // This function inserts soft hyphens (&shy;) into long words,
  // at intervals given by {step}. The soft hyphens do not show up
  // until a break is actually required.

  if (!text) {
    return text;
  }
  var softHyphen = '\u00AD';
  var chunkMatcher = new RegExp(".{1,".concat(step, "}"), 'g');
  return text.split(/\s+/).map(word => {
    var _word$match;
    return (_word$match = word.match(chunkMatcher)) === null || _word$match === void 0 ? void 0 : _word$match.join(softHyphen);
  }).join(' ');
}
function FallbackProfile(_ref) {
  var {
    msg
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.profileContainer, " p-8 bg-bluegray-50 text-center")
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.profileLogo, " ").concat(classes.profileLogoFallback)
  }, /*#__PURE__*/React.createElement("svg", {
    width: "102",
    height: "102",
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.7433 12.5176C40.912 14.1231 48.4336 22.5324 48.1799 31.2782C48.1145 33.5343 47.5876 35.8078 46.6819 37.9616C55.2019 45.4951 79.1895 66.767 85.0679 72.6447C88.9563 76.5332 90.0537 82.1946 85.7443 86.5041C81.5185 90.7298 76.4481 90.7298 71.5467 85.8277C65.7606 80.0422 44.6769 57.3135 36.6941 48.6907C34.8804 49.5785 32.9169 50.1681 30.8566 50.3771C22.054 51.2699 15.9583 44.627 15.4848 44.0942L15.4625 44.069C15.4576 44.0633 15.4551 44.0604 15.4551 44.0604L33.5182 25.9964L21.4336 13.9118C21.4336 13.9118 27.1719 10.5476 34.7433 12.5176ZM75.1804 76.1099C73.1267 78.1636 73.1267 81.4932 75.1804 83.546C77.2341 85.6006 80.5637 85.6006 82.6174 83.546C84.6711 81.4932 84.6711 78.1636 82.6174 76.1099C80.5637 74.0562 77.2341 74.0562 75.1804 76.1099Z",
    fill: "#ACB1BA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.0763 35.8553C35.3841 30.9654 36.9127 29.9651 39.1389 33.7925L39.902 33.0304L43.3618 36.4902L41.2619 38.5909C42.8842 43.428 41.5039 44.5311 39.2316 40.6211L37.5579 42.2946C39.1802 47.1313 37.8 48.2348 35.5277 44.325L34.8299 45.022L31.3701 41.5623L33.3725 39.5596C31.6801 34.6692 33.2088 33.6689 35.4352 37.4968L37.0763 35.8553Z",
    fill: "#767676"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6133 21.289L26.4198 33.0955L19.2602 40.2551C19.2602 40.2551 15.4512 37.0558 13.8524 32.2576C11.8105 26.132 14.6133 21.289 14.6133 21.289Z",
    fill: "#909296"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.profileContent, " mt-8 mb-12 text-center")
  }, /*#__PURE__*/React.createElement("h3", {
    className: "mb-16"
  }, "Beklager, n\xE5 er det rusk i maskineriet."), /*#__PURE__*/React.createElement("p", null, msg)));
}

function contacts$1(contactList, orgName, deviceType, adId) {
  return contactList.map((contact, index) => {
    var buttonDestination = adId ? "/contact/".concat(adId, "/?ci=").concat(index) : '#';
    var phonesAndUrl = contact.phone.reduce((accumulator, currentValue, idx) => {
      var always = /*#__PURE__*/React.createElement("a", {
        key: "basic-profile-phidx-".concat(idx),
        href: currentValue.phoneAsLink,
        onClick: () => {
          if (adId) trackPhonenr(adId, orgName);
        }
      }, currentValue.phoneFormatted);
      if (currentValue.type === 'MOBILE' && (deviceType === 'mobile' || deviceType === 'tablet')) {
        return [...accumulator, always, /*#__PURE__*/React.createElement("a", {
          key: "basic-profile-smsidx-".concat(idx),
          href: currentValue.phoneAsSmsLink,
          onClick: () => {
            if (adId) trackSms(adId, orgName);
          }
        }, "Send SMS")];
      }
      return [...accumulator, always];
    }, []);
    if (contact.url) {
      var absoluteUrl = contact.url.startsWith('http') ? contact.url : "http://".concat(contact.url);
      phonesAndUrl.push(
      /*#__PURE__*/
      /* eslint-disable-next-line react/jsx-no-target-blank */
      React.createElement("a", {
        href: absoluteUrl,
        target: "_blank",
        rel: "noopener external ugc",
        onClick: () => {
          if (adId) trackHjemmeside(adId, orgName);
        }
      }, "Hjemmeside"));
    }
    return /*#__PURE__*/React.createElement("div", {
      className: "mb-16",
      key: contact.name
    }, /*#__PURE__*/React.createElement("h3", {
      "aria-label": "Kontaktperson",
      className: "text-16 mb-4"
    }, contact.name), contact.title ? /*#__PURE__*/React.createElement("p", {
      className: "text-12 mb-4"
    }, contact.title) : /*#__PURE__*/React.createElement(React.Fragment, null), /*#__PURE__*/React.createElement("div", {
      className: "grid f-grid grid-cols-2 gap-y-8 gap-x-32 mb-16 whitespace-nowrap"
    }, phonesAndUrl), contact.email && /*#__PURE__*/React.createElement("a", {
      href: buttonDestination,
      rel: "nofollow",
      className: "button--cta button button--primary w-full min-w-full max-w-none justify-center text-white",
      onClick: () => {
        if (adId) trackSendMelding();
      }
    }, "Send melding"));
  });
}
function contactsHasUrl(contactList) {
  return contactList.filter(c => {
    var _c$url;
    return (_c$url = c.url) !== null && _c$url !== void 0 ? _c$url : false;
  }).length > 0;
}
var defaultProps$1 = {
  adId: null
};
function RealEstateBasicProfile(_ref) {
  var {
    bpre,
    deviceType,
    adId
  } = _ref;
  return /*#__PURE__*/React.createElement("section", {
    "aria-label": "Profil",
    className: classes.profileContainer
  }, bpre.logo && /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.profileLogo)
  }, /*#__PURE__*/React.createElement("img", {
    src: bpre.logo,
    alt: "Logo"
  })), /*#__PURE__*/React.createElement("div", {
    className: "p-16 bg-bluegray-50"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "".concat(classes.companyName, " font-normal text-16")
  }, insertSoftHyphens(bpre.orgName)), contacts$1(bpre.contacts, bpre.orgName, deviceType, adId), bpre.homepageUrl && !contactsHasUrl(bpre.contacts) && /*#__PURE__*/React.createElement("div", {
    className: "mt-16"
  }, /*#__PURE__*/React.createElement("a", {
    href: bpre.homepageUrl,
    target: "_blank",
    rel: "noopener external ugc",
    onClick: () => {
      if (adId) trackHjemmeside(adId, bpre.orgName);
    }
  }, "Hjemmeside")), !bpre.suppressMoreAdsFrom && /*#__PURE__*/React.createElement("div", {
    className: "mt-16"
  }, /*#__PURE__*/React.createElement("a", {
    href: bpre.moreFromLink,
    rel: "nofollow",
    onClick: () => {
      if (adId) trackMoreAdsFrom(adId);
    }
  }, "Flere annonser fra annons\xF8r"))));
}
RealEstateBasicProfile.defaultProps = defaultProps$1;

function contacts(contact, orgName, deviceType, adId) {
  var phonesAndUrl = contact.phone && contact.phone.reduce((accumulator, currentValue, idx) => {
    var always = /*#__PURE__*/React.createElement("a", {
      key: "basic-profile-phidx-".concat(idx),
      href: currentValue.phoneAsLink,
      onClick: () => {
        if (adId) trackPhonenr(adId, orgName);
      }
    }, currentValue.phoneFormatted);
    if (currentValue.type === 'MOBILE' && (deviceType === 'mobile' || deviceType === 'tablet')) {
      return [...accumulator, always, /*#__PURE__*/React.createElement("a", {
        key: "basic-profile-smsidx-".concat(idx),
        href: currentValue.phoneAsSmsLink,
        onClick: () => {
          if (adId) trackSms(adId, orgName);
        }
      }, "Send SMS")];
    }
    return [...accumulator, always];
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h3", {
    "aria-label": "Kontaktperson",
    className: "text-16 mb-4"
  }, contact.name), /*#__PURE__*/React.createElement("div", {
    className: "grid f-grid grid-cols-2 gap-y-8 gap-x-32 mb-8 whitespace-nowrap"
  }, phonesAndUrl));
}
var defaultProps = {
  adId: null
};
function MobilityBasicProfile(_ref) {
  var {
    bpm,
    deviceType,
    adId
  } = _ref;
  var buttonDestination = adId ? "/contact/".concat(adId) : '#';
  return /*#__PURE__*/React.createElement("section", {
    "aria-label": "Profil",
    className: classes.profileContainer
  }, bpm.logo && /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.profileLogo)
  }, /*#__PURE__*/React.createElement("img", {
    src: bpm.logo,
    alt: "Logo"
  })), /*#__PURE__*/React.createElement("div", {
    className: "p-16 bg-bluegray-50"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "".concat(classes.companyName, " font-normal text-16")
  }, insertSoftHyphens(bpm.orgName)), bpm.contact && contacts(bpm.contact, bpm.orgName, deviceType, adId), (bpm.contact.url || bpm.homepageUrl) && /*#__PURE__*/React.createElement("div", {
    className: "mb-16"
  }, /*#__PURE__*/React.createElement("a", {
    href: bpm.contact.url !== undefined ? bpm.contact.url : bpm.homepageUrl,
    target: "_blank",
    rel: "noopener external ugc noreferrer",
    onClick: () => {
      if (adId) trackHjemmeside(adId, bpm.orgName);
    }
  }, "Hjemmeside")), bpm.contact.email && /*#__PURE__*/React.createElement("a", {
    href: buttonDestination,
    rel: "nofollow",
    className: "button--cta button button--primary w-full min-w-full max-w-none justify-center text-white",
    onClick: () => {
      if (adId) trackSendMelding();
    }
  }, "Send melding"), !bpm.suppressMoreAdsFrom && /*#__PURE__*/React.createElement("div", {
    className: "mt-16"
  }, /*#__PURE__*/React.createElement("a", {
    href: bpm.moreFromLink,
    rel: "nofollow",
    onClick: () => {
      if (adId) trackMoreAdsFrom(adId);
    }
  }, "Flere annonser fra oss"))));
}
MobilityBasicProfile.defaultProps = defaultProps;

export { FallbackProfile, MobilityBasicProfile, RealEstateBasicProfile };
//# sourceMappingURL=index.js.map
